"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  navButton: {
    position: 'absolute',
    top: 'calc(50% - 20px)',
    borderRadius: '50%',
    height: '40px',
    width: '40px',
    backgroundColor: 'white',
    border: 0,
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
    color: _theme.default.palette.primary.light
  },
  navButtonRight: {
    left: 'auto',
    right: '-20px'
  },
  navButtonLeft: {
    left: '-20px',
    right: 'auto'
  }
});
var _default = exports.default = useStyles;